import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import { CustomModal, StyledProgress } from './styled';
import { DDMMYYYYHHMMTimeFormatForFileDownload } from '../../../../util/GlobalConstant';
import moment from 'moment';
import { downloadFile } from '../../../cm/utils/common';

const DownloadModal = ({
  visible = false,
  onCancel,
  img,
  contentTitle,
  contentDescription,
  ghostBtnText,
  primaryBtnText,
  percentageCompletion,
  stopDownload,
  csvData
}) => {
  const handleDownloadCsv = (ghostBtnText) => {
    if (ghostBtnText == 'Close') {
      onCancel();
      return;
    }
    const blob = csvData?.blob;
    if (!blob) return;
    const fallbackName = `Alert_History__${moment().format(
      DDMMYYYYHHMMTimeFormatForFileDownload
    )}.csv`;
    const fileName = csvData?.fileName || fallbackName;
    downloadFile(blob, fileName);
  };

  const handlePrimaryButtonClick = () => {
    stopDownload();
  };

  return (
    <CustomModal
      visible={visible}
      onCancel={onCancel}
      width={435}
      height={440}
      closeIcon={
        <CloseOutlined
          style={{
            color: '#50769F',
            width: '15.04px',
            height: '15.04px',
            top: '16px',
            left: '406.63px',
            opacity: 0.25
          }}
        />
      }
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            handleDownloadCsv(ghostBtnText);
          }}
          type="primary"
          ghost
          style={{
            color: '#2B73E0',
            fontSize: '12px',
            lineHeight: '20px',
            fontWeight: '400',
            minWidth: '83px',
            minHeight: '30px'
          }}>
          {ghostBtnText}
        </Button>,
        <Button
          key="submit"
          type="primary"
          style={{
            backgroundColor: '#2B73E0',
            minWidth: '116px',
            minHeight: '30px',
            fontSize: '12px',
            lineHeight: '20px',
            fontWeight: '400',
            color: '#FFFFFF'
          }}
          onClick={() => {
            handlePrimaryButtonClick();
          }}>
          {primaryBtnText}
        </Button>
      ]}>
      <div className="custom-modal-content">
        <img className="custom-image" src={img} alt="Custom Modal Image" />
        <div style={{ marginTop: '-40px' }}>
          <p
            style={{
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '21.67px',
              color: '#31394D',
              marginBottom: '4px',
              textAlign: 'center'
            }}>
            {contentTitle}
          </p>
          <p
            style={{
              fontSize: '11px',
              fontWeight: '400',
              lineHeight: '21.67px',
              color: '#748AA1',
              textAlign: 'center',
              margin: '-2px 0px 0px 4px'
            }}>
            {contentDescription}
          </p>
        </div>
        <StyledProgress
          percent={percentageCompletion}
          format={(percentageCompletion) =>
            percentageCompletion === 100 ? '100%' : `${percentageCompletion}%`
          }
        />
      </div>
    </CustomModal>
  );
};

DownloadModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  img: PropTypes.string.isRequired,
  contentTitle: PropTypes.string,
  contentDescription: PropTypes.string,
  ghostBtnText: PropTypes.string,
  primaryBtnText: PropTypes.string,
  percentageCompletion: PropTypes.string,
  stopDownload: PropTypes.func.isRequired,
  csvData: PropTypes.object
};

export default DownloadModal;
